module.exports = __webpack_public_path__ + "static/media/Theme4.bbb8de84.png";